var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3054 8.59333L7.71246 6L10.3054 3.40667C10.3671 3.34494 10.416 3.27167 10.4494 3.19103C10.4828 3.11039 10.5 3.02395 10.5 2.93667C10.5 2.84938 10.4828 2.76295 10.4494 2.6823C10.416 2.60166 10.3671 2.52839 10.3054 2.46667C10.2436 2.40495 10.1704 2.35599 10.0898 2.32258C10.0091 2.28918 9.9227 2.27199 9.83543 2.27199C9.74816 2.27199 9.66174 2.28918 9.58111 2.32258C9.50048 2.35599 9.42722 2.40495 9.36551 2.46667L6.30603 5.52667C6.24423 5.58834 6.19521 5.6616 6.16176 5.74225C6.12831 5.8229 6.1111 5.90935 6.1111 5.99667C6.1111 6.08398 6.12831 6.17043 6.16176 6.25108C6.19521 6.33173 6.24423 6.40499 6.30603 6.46667L9.36551 9.53333C9.42718 9.59514 9.50042 9.64417 9.58106 9.67762C9.66169 9.71108 9.74813 9.7283 9.83543 9.7283C9.92273 9.7283 10.0092 9.71108 10.0898 9.67762C10.1704 9.64417 10.2437 9.59514 10.3054 9.53333C10.5586 9.27333 10.5586 8.84667 10.3054 8.59333ZM3.16655 10C2.79995 10 2.5 9.7 2.5 9.33333L2.5 2.66667C2.5 2.3 2.79995 2 3.16655 2C3.53316 2 3.83311 2.3 3.83311 2.66667L3.83311 9.33333C3.83311 9.7 3.53316 10 3.16655 10Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.380d07d049d02fc002278479e6684e39.svg";
export { ForwardRef as ReactComponent };